module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"form-list-title":"Modification d\u0027un contact","submit-create-label":"Créer","submit-update-label":"Modifier","delete-label":"Supprimer","contact-title":"Contact"},"de":{"form-list-title":"Änderung eines Kontakts","submit-create-label":"Erstellen","submit-update-label":"Modifizieren","delete-label":"Löschen","contact-title":"Kontact"}}')
  delete Component.options._Ctor
}
